import {
  LeaderboardSortingOption,
  LeaderboardCompany,
} from "lib/types/leaderboards";

type SortType = {
  key: LeaderboardSortingOption;
  value: "ASC" | "DESC";
};

export const sortTable = (list: LeaderboardCompany[], sort: SortType) => {
  if (sort.key === "rank") {
    return list.sort((a, b) => {
      if (sort.value === "DESC") {
        return a.rank > b.rank ? 1 : -1;
      }

      return a.rank > b.rank ? -1 : 1;
    });
  }

  return list.sort((a, b) => {
    const valA = a[sort.key] as number;
    const valB = b[sort.key] as number;

    if (sort.value === "DESC") {
      return valA > valB ? -1 : 1;
    }

    return valA > valB ? 1 : -1;
  });
};
